import datapoints from '../datapoints';
import { setFolderSortBy, isSortingPersisted } from 'owa-mail-folder-store';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import { ActionSource } from 'owa-mail-store';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import * as undoActions from 'owa-mail-undo';
import SortDirection from 'owa-service/lib/contract/SortDirection';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import {
    getFocusedFilterForTable,
    SortBy,
    SortColumn,
    MailSortHelper,
    listViewStore,
    TableView,
    MailFolderTableQuery,
    getInboxClassificationFilterForTable,
} from 'owa-mail-list-store';
import { action } from 'satcheljs/lib/legacy';

const selectSortInternal = createLegacyActionWithDatapoint(
    'selectSortInternal',
    datapoints.selectSort
)(function selectSortInternal(
    sortColumnToSelect: SortColumn,
    sortDirectionToSelect: SortDirection,
    tableView: TableView,
    actionSource: ActionSource
): Promise<void> {
    const sortBy: SortBy = {
        sortColumn: sortColumnToSelect,
        sortDirection: sortDirectionToSelect,
    };

    const tableQuery = createMailFolderTableQuery(
        tableView.tableQuery.folderId,
        tableView.tableQuery.listViewType,
        (tableView.tableQuery as MailFolderTableQuery).scenarioType,
        getFocusedFilterForTable(tableView),
        'All',
        null /* categoryName */, // Support sort - VSO: 23489 - Category Filter Drop down menu to show in category list view and category search
        sortBy, // sortBy selected by the user
        getInboxClassificationFilterForTable(tableView.id)
    );

    if (isSortingPersisted()) {
        setFolderSortBy(tableView.tableQuery.folderId, sortColumnToSelect, sortDirectionToSelect);
    }

    return loadTableViewFromTableQuery(tableQuery);
});

/**
 * Selects the sort on the current selected table
 * @param sortColumn selected by the user
 * @param tableViewId table view id
 * @param actionSource source of this action
 */
export default action('selectSort')(function selectSort(
    sortColumn: SortColumn,
    sortDirection: SortDirection,
    tableViewId: string,
    actionSource: ActionSource
) {
    const tableView = listViewStore.tableViews.get(tableViewId);
    const currentSortBy = (tableView.tableQuery as MailFolderTableQuery).sortBy;

    if (currentSortBy.sortColumn == sortColumn && currentSortBy.sortDirection == sortDirection) {
        return;
    }

    selectSortInternal(
        sortColumn,
        sortDirection ? sortDirection : getSortDirection(tableView, sortColumn), // Once tri-filterMenuRedesign graduates, this will simply be sortDirection and getSortDirection function will be removed
        tableView,
        actionSource
    );
    undoActions.clearLastUndoableAction();
    listViewStore.rowInfoForVLV.clear();
    listViewStore.scrollTop = 0;
});

function getSortDirection(tableView: TableView, sortColumn: SortColumn) {
    const currentSortBy = (tableView.tableQuery as MailFolderTableQuery).sortBy;
    const isSameSortColumnSelected = currentSortBy.sortColumn == sortColumn;

    if (isSameSortColumnSelected) {
        // If same sort is selected then toggle the sort direction and load the table
        return currentSortBy.sortDirection == MailSortHelper.ASCENDING_SORT_DIR
            ? MailSortHelper.DESCENDING_SORT_DIR
            : MailSortHelper.ASCENDING_SORT_DIR;
    }

    // If different sort is selected then get the default sort direction for this sort column
    return MailSortHelper.getDefaulSortDirectionForSortColumn(sortColumn);
}
